import { Component, Vue, Prop } from "vue-property-decorator";
import { SubmenuItem } from "..";
import { Dropdown, Menu, Icon } from "ant-design-vue";
import Flag from "@/assets/flags/en.svg";
import { fmtMsg, GLGlobal, GLUtil } from "commonui";
import { ImpersonationLocale } from "@/locales/localeid";

@Component({
	components: {
		Icon,
		Dropdown: Dropdown,
		Menu,
		MenuItem: Menu.Item
	}
})
export default class VcHeaderMenuItem extends Vue {
	@Prop() readonly icon!: string;
	@Prop() readonly iconImg!: string;
	@Prop() readonly title!: string;
	@Prop() readonly subtitle!: string;
	@Prop({ default: "/" }) readonly url!: string;
	@Prop() readonly isExternal!: boolean;
	@Prop({ type: Array, default: () => [] }) readonly submenus!: Array<SubmenuItem>;
	@Prop({ default: 200 }) readonly submenuWidth!: number;
	@Prop() readonly rounded!: boolean;
	@Prop() readonly isSignInMenu!: boolean;

	menuClick() {
		this.$emit("click");
	}

	dropdownMenuClick(menuItem: SubmenuItem) {
		if (menuItem.clickEvent) {
			this.$emit(menuItem.clickEvent, menuItem);
		}
	}

	get flag() {
		return Flag;
	}

	switchBack = () => {
		const code = GLUtil.getImpersonationSwitchBackCode();
		if (!code) {
			return "";
		}
		location.href =
			GLGlobal.authorityUrl() +
			"/Impersonation/SwitchBack?code=" +
			code.switchBackCode +
			"&uid=" +
			code.impersonatedByUserId;
	};

	get isImpersonating() {
		return GLUtil.isImpersonating();
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	get impersonationLocale() {
		return ImpersonationLocale;
	}
}
